import React, { useEffect, useState } from "react";
import { ButtonSelect } from "../../../form-inputs/inputs";
import { useInput } from "../../../../shared/hooks/form-fields";

const filterUsed = (upcs, currentKey, currentSortOrder, unusable) => {
    return upcs.reduce(
        (usable, upc) => {
            if (upc.key === currentKey || !upc.packageLevel || !upc.packageLevel.text) {
                return usable;
            }

            if (!unusable.includes(upc.key)) {
                const packageLevel = upc.packageLevel && upc.packageLevel.text ? ` (${upc.packageLevel.text})` : "";
                const fullUpc = upc.modifier ? `${upc.upc}-${upc.modifier}` : upc.upc;

                if (upc.packageLevel.sortOrder > currentSortOrder) {
                    usable.parents.push({ value: upc.key, text: `${fullUpc} ${packageLevel}` });
                } else if (upc.packageLevel.sortOrder < currentSortOrder) {
                    usable.children.push({ value: upc.key, text: `${fullUpc} ${packageLevel}` });
                }
            }

            return usable;
        },
        { parents: [], children: [] }
    );
};

const buildList = (upcs, keys, removeItem) => {
    return upcs.reduce((items, upc) => {
        if (keys.includes(upc.key)) {
            const packageLevel = upc.packageLevel && upc.packageLevel.text ? ` (${upc.packageLevel.text})` : "";
            const fullUpc = upc.modifier ? `${upc.upc}-${upc.modifier}` : upc.upc;
            items.push(
                <div key={upc.key} className="button-group">
                    {fullUpc} {packageLevel}
                    <button
                        className="button -small -right"
                        onClick={() => {
                            removeItem(upc.key);
                        }}
                    >
                        X
                    </button>
                </div>
            );
        }

        return items;
    }, []);
};

const PackageHierarchy = (props) => {
    const childUpcInput = useInput("");
    const parentUpcInput = useInput("");
    const [usableOptions, setUsableOptions] = useState({ parents: [], children: [] });

    useEffect(() => {
        childUpcInput.reset();
    }, [props.childUPCs]);

    useEffect(() => {
        const usable =
            props.currentPackageLevel && props.currentPackageLevel.sortOrder
                ? filterUsed(props.upcs, props.currentKey, props.currentPackageLevel.sortOrder, [...props.childKeys, ...props.parentKeys])
                : { parents: [], children: [] };
        setUsableOptions(usable);
    }, [props.upcs, props.childKeys, props.parentKeys, props.currentKey, props.currentPackageLevel]);

    const addChild = () => {
        if (!childUpcInput.value) {
            return;
        }

        const newUpcs = [...props.childKeys, childUpcInput.value];
        props.updateState("childProductKeys", newUpcs);
        childUpcInput.reset();
    };

    const addParent = () => {
        if (!parentUpcInput.value) {
            return;
        }

        const newUpcs = [...props.parentKeys, parentUpcInput.value];
        props.updateState("parentProductKeys", newUpcs);
        parentUpcInput.reset();
    };
    const removeParent = (key) => {
        if (!key) {
            return;
        }

        const newUpcs = props.parentKeys.filter((k) => k !== key);
        props.updateState("parentProductKeys", newUpcs);
    };
    const removeChild = (key) => {
        if (!key) {
            return;
        }

        const newKeys = props.childKeys.filter((k) => k !== key);
        props.updateState("childProductKeys", newKeys);
    };

    const parents = buildList(props.upcs, props.parentKeys, removeParent);
    const children = buildList(props.upcs, props.childKeys, removeChild);

    return (
        <div>
            {!props.currentPackageLevel && (
                <p className="txt-error txt-center">
                    Please select a Package level
                    <br />
                    for Package Hierarchy options
                </p>
            )}
            <div className="row">
                <div className="column -span6">
                    <ButtonSelect {...parentUpcInput.bind} label="Parents" options={usableOptions.parents} buttonClick={addParent} />
                    {parents}
                </div>
                <div className="column -span6">
                    <ButtonSelect {...childUpcInput.bind} label="Children" options={usableOptions.children} buttonClick={addChild} />
                    {children}
                </div>
            </div>
        </div>
    );
};

PackageHierarchy.defaultProps = {
    childKeys: [],
    parentKeys: [],
};

export default PackageHierarchy;
